import type { ReportScheduleListParams, ReportSchedulerStatus } from '../types'

export const DEFAULT_REPORT_SCHEDULE_LIST_PARAMS: ReportScheduleListParams = {
  page: 1,
  perPage: 15,
  sortBy: 'desc',
  orderBy: 'created_at',
}

export const STATUS_LABEL: Record<ReportSchedulerStatus, string> = {
  RUNNING: 'Running',
  PAUSED: 'Paused',
}

export const EMPTY_MESSAGE = 'No report schedules found.'

/** Same pattern as stock registry / document management modals — calendar in portal. */
export const SCHEDULE_START_DATE_PICKER_PROPS = {
  allowFutureDates: true,
  showHelperText: false,
  popperFixed: true,
  popperPlacement: 'top-start' as const,
  placeholder: 'MM/DD/YYYY',
  minDate: new Date(1900, 0, 1),
  maxDate: new Date(2099, 11, 30),
}
